<template>
  <d-container fluid class="main-content-container px-4 pb-4">
      <header class="site-header"></header>
      <div class="container">
        <div class="manage-account">
        <h2 class="page-title">STTAA Admin</h2>
        <div class="login-register-wrapper">
        <d-form>
        <form style="width:100%">
          <d-form-row>
            <d-col md="12" class="form-group">
              <label for="username">Username</label>
                <d-form-input id="username" name="username" v-model="username" required autofocus type="text" />
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="12" class="form-group">
              <label for="password">Password</label>
                <d-form-input id="password" name="password" v-model="password" type="password" required />
            </d-col>
            <div style="min-height:30px;margin-top:5px;color:red;font-size:.8rem;">
              {{error_str}}
            </div>
          </d-form-row>
            <div>
              <d-button pill type="submit" @click="handleSubmit" :disabled="loading" style="float:right">
                Log In
              </d-button>
            </div>
        </form>
        </d-form>
        </div>
        </div>
      </div>
  </d-container>
</template>
<style>
label {
    font-size: 12px;
    font-weight: 400;
    letter-spacing: -.1px;
    line-height: 1;
    display: inline-block;
    margin-bottom: .5rem;
}
input[type="password"], input[type="text"] {
    padding: 7px 5px;
    border-radius: 4px;
    font-size: 14px;
    background: #fff;
    border: 1px solid #dbdee5;
    transition: all .3s ease-in-out;
}
  .site-header{
    padding-top: 2.813rem;
    margin-bottom: 4.375rem;
  }
  .container {
    width: 90%;
    position: relative;
    margin: 0 auto;
  }
  .manage-account .page-title {
    font-size: 1.813rem;
    margin-bottom: 50px;
    text-align: center;
  }  
  .login-register-wrapper {
    display: table;
    max-width: 340px;
    margin: 0 auto;
    margin-bottom: 0px;
    background: #fff;
    margin-bottom: 6.912rem;
    padding: 25px;
    box-shadow: 0 .313rem 7.813rem rgba(42,42,100,.125),0 .063rem 2.5rem rgba(0,0,0,.03);
  }
</style>
<script>
import axios from 'axios';
import env from '../env.vue';

export default {
  data(){
    return{
      username:'',
      password:'',
      error_str:'',
      loading:false,
    }
  },
  methods: {
    register(){
      this.$router.push('/register');
    },
    handleSubmit(e){
      e.preventDefault()
      this.error_str=''
      this.loading=true
      axios.post(env.server+'/auth/login', 
      {
        username_or_email:this.username,
        password:this.password,
        active:true,
      }
      ).then(resp => {
        this.loading=false;
        this.$store.commit('token', resp.data.data.token );
        this.$store.commit('name', resp.data.data.name );
        console.log('resp',resp.data);
        this.$router.push('/');
      }).catch( error => {
        this.error_str='Invalid email / password';
        this.loading=false;
      });
    }
  }
};
</script>
